import { observer } from "mobx-react-lite"
import { useEffect, useCallback, useRef } from "react"
import historySearchStore from "@/store/historySearch"
import navbarStore from "@/store/navbar"
import { RobotsMap } from '@/common/localRobot.js';
import globalStore from "@/store/global";
import InfiniteScroll from 'react-infinite-scroll-component';
import { AssistantType } from '@shared/constants/chat';
import AisoItem from "./aiso-item";
import { goSearchHistory, newSearch } from '@src/pages/search';
import "./index.scss"

const HistorySearch = observer(({ scene="", type = 'chat' }) => {
  const getIcon = useCallback(
    role_id => {
      const item = navbarStore.specifyList?.find(item => item.id == role_id) || RobotsMap[role_id];
      return item || {icon: 'https://p4.ssl.qhimg.com/t110b9a930179fa89dbae660a1a.png'};
    },
    [navbarStore.specifyList, navbarStore.chatModels]
  );

  const renderChatItem = (item, index) =>{
    const date = new Date(item.create_time)
    const {
      data_source = 1,
      conversation_id,
      alias_title,
      title,
      aiso_img_search,
      icon,
      content,
    } = item;
    return (
      <div 
        key={index}
        className="h-36px rounded-8px hover:bg-[#00000008] cursor-pointer flex items-center navbar-search-item"
        onClick={() => {
          if (navbarStore.sourceId === 1) {
            if (data_source === 1) {
              goSearchHistory(conversation_id);
            } else if (data_source === 2) {
              globalStore.navigate(`/aichat/${conversation_id}`);
            }
          }else if (navbarStore.sourceId === 2) {
            // 大模型搜索结果页
            globalStore.navigate(`/chat/${item.conversation_id}`, {
              state: { history: true },
            });
          }else if (navbarStore.sourceId === 3) {
            // AI助手搜索结果页
            globalStore.navigate(`/agentchat/${item.conversation_id}`, {
              state: { history: true },
            });
          }
        }}
      >
        {/* <img 
          src={item?.agent_id ? (item?.agent_info?.icon || 'https://p4.ssl.qhimg.com/t110b9a930179fa89dbae660a1a.png') : (getIcon(item.role_id)?.icon || 'https://p4.ssl.qhimg.com/t110b9a930179fa89dbae660a1a.png')}
          className="size-20px rounded-full overflow-hidden border-solid border-1px border-[rgba(0,0,0,0.06)] ml-6px"  
        /> */}
        {
          item?.chat_type === AssistantType.LocalModel ? (
            <span className={`flex-shrink-0 ml-6px h-18px px-6px flex items-center font-bold-600mr-6px rounded-4px text-12px bg-[#0058FF] bg-opacity-10 text-[#0058FF] ${globalStore.isDark? 'bg-[#2780FE] !bg-opacity-10 !text-[#2780FE]':''}`}>本地</span>
            ) : null
        }
        {
          (item.chat_type === AssistantType.APIModel) && (
            <span className={`flex-shrink-0 h-18px px-6px flex items-center font-bold-600 ml-6px  rounded-4px text-12px bg-[#E43F9F] bg-opacity-10 text-[#E43F9F]`}>API</span>
          )
        }
        {
          (item.chat_type === AssistantType.PrivateModel) && (
            <span className={`flex-shrink-0 h-18px px-6px flex items-center font-bold-600 ml-6px rounded-4px text-12px bg-[#FF7307] bg-opacity-10 text-[#FF7307]`}>私有</span>
          )
        }
        <div
          className="mx-8px w-0 flex-grow truncate text-14px text-black"
          dangerouslySetInnerHTML={{
            __html: item.content || item.title
          }}
        ></div>
        <div className="text-11px text-black opacity-50 mr-6px">
          { date.getMonth() + 1 + "月" + date.getDate() + "日" }
        </div>
      </div>
    )
  }

  const renderAisoItem = (item, index) => {
    return (
      <AisoItem
        key={index}
        item={item}
        getIcon={getIcon}
        scene={scene}
        isSearch={true}
      />
    );
  }

  return (
    <div
      id="search_history_wrap"
      className="h-0 flex-grow overflow-y-auto nw-no-scroll"
    >
      {
        historySearchStore.data.list.length
        ? (
          <InfiniteScroll
            dataLength={historySearchStore.data.list.length}
            next={evt => {
              historySearchStore.getList(scene == "aigent" ? 1 : 5)
            }}
            hasMore={!!historySearchStore.data.npt}
            loader={<div className="text-center text-12px opacity-50">加载中...</div>}
            scrollableTarget="search_history_wrap"
            className='px-14px flex flex-col gap-12px'
          >
            {
              historySearchStore.data.list.map((item, index) => {
                if (type === 'chat') {
                  return renderChatItem(item, index);
                } else if (type === 'aiso') {
                  return renderAisoItem(item, index);
                } else {
                  return renderChatItem(item, index);
                }
                return null;
              })
            }
          </InfiniteScroll>
        )
        : (
          <div className="mt-120px text-center text-14px text-black opacity-50">
            {
              historySearchStore.data.loading
              ? "加载中"
              : "没有结果"
            }
          </div>
        )
      }
    </div>
  )
})

export default HistorySearch